// :cow: Cosmose CONFIDENTIAL :iso:
import { inject, Injectable } from '@angular/core';
import { ToastService } from 'ngx-toastr-notifier';

const TOAST_OPTIONS = {
  duration: 5000,
  showClose: true,
  horizontalPosition: 'left' as const,
  verticalPosition: 'bottom' as const,
};

@Injectable({
  providedIn: 'root',
})
export class SnackbarService {
  private readonly toastService = inject(ToastService);

  success(message: string) {
    this.toastService.success(message, 'Success', TOAST_OPTIONS);
  }

  error(message: string) {
    this.toastService.error(message, 'Error', TOAST_OPTIONS);
  }

  info(message: string) {
    this.toastService.info(message, 'Info', TOAST_OPTIONS);
  }

  warning(message: string) {
    this.toastService.warning(message, 'Warning', TOAST_OPTIONS);
  }
}
